/**
 * 侧栏工具条相关纯逻辑（从 Dashboard 拆出）
 */
import { ONLINE_TIMEOUT } from './constants';
import { getCurrentUserId } from '../userSettings';
import { trackModeLocalKey, clearLegacySharedTrackModeKeys } from './dashboardSettingsHelpers';

export function listOnlineMembersForToolbar(members = [], now = Date.now(), timeout = ONLINE_TIMEOUT) {
  return (members || []).filter((member) => {
    if (!member?.last_seen) return false;
    const lastSeenTime = new Date(member.last_seen).getTime();
    return !Number.isNaN(lastSeenTime) && now - lastSeenTime < timeout;
  });
}

export function buildResetDashboardFiltersPatch() {
  return {
    startTime: '',
    endTime: '',
    hideInvalid: false,
    showOnlineOnly: false,
    trackMode: 'recent',
    trackMinutes: 60,
    trackHours: 1,
    trackDays: 1,
    playbackRange: { start: null, end: null },
    isPlaying: false,
    playbackIndex: 0,
    trackModeApplied: false
  };
}

export function clearTrackModeLocalStorage(storage = typeof localStorage !== 'undefined' ? localStorage : null) {
  if (!storage) return;
  try {
    clearLegacySharedTrackModeKeys(storage);
    const uid = getCurrentUserId?.();
    if (uid != null && String(uid) !== '') {
      ['dashboard_trackMode', 'dashboard_trackMinutes', 'dashboard_trackHours', 'dashboard_trackDays',
        'dashboard_trackModeApplied', 'dashboard_lastAppliedTrackMode'].forEach((base) => {
        storage.removeItem(trackModeLocalKey(base, uid));
      });
    }
  } catch (_) {
    /* ignore */
  }
}

export function requestReplayEarthAnimation(
  storage = typeof sessionStorage !== 'undefined' ? sessionStorage : null
) {
  if (!storage) return false;
  try {
    storage.setItem('showEarthAnimation', 'true');
    return true;
  } catch (_) {
    return false;
  }
}
